import script from "./VerifyBankAccountModel.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyBankAccountModel.vue?vue&type=script&setup=true&lang=js"

import "./VerifyBankAccountModel.vue?vue&type=style&index=0&id=847901b4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-847901b4"]])

export default __exports__